module.exports = __webpack_public_path__ + "static/img/serviceContent1.32884835.png";